<template>
  <div class="custom-list">
    <v-row no-gutters class="ma-0">
      <v-col cols="12">
        <v-card elevation="0" class="pa-4 list-box-Shadow">
          <v-row no-gutters>
            <v-col cols="6" class="text-left d-flex align-center">
              <h3 class="text-uppercase font-weight-bold text_color--text">
                {{ integrationLogsModule.integrationDocPlural }}
              </h3>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>

    <v-row class="ma-0 Height-Class align-center" justify="center">
      <v-col cols="6">
        <v-card class="rounded-lg" flat>
          <v-card-title class="heading lighten-3 text_color--text">
            <h5 class="font-weight-normal primary--text">
              Integration Document
            </h5>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text class="pa-10 text-center">
            <PrimaryButton
              @click="redirectopostman"
              name="Postman Document"
              large
            >
            </PrimaryButton>
            <PrimaryButton
              @click="redirectswagger"
              name="Swagger Document"
              large
              class="ml-3"
            >
            </PrimaryButton>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { integrationLogsModule } from "@/utils/moduleMapping";
export default {
  data() {
    return {
      integrationLogsModule,
    };
  },
  methods: {
    redirectswagger() {
      let swaggerdoc = document.createElement("a");
      swaggerdoc.target = "_blank";
      swaggerdoc.href = process.env.VUE_APP_BASE_URL + "/swagger/doc/";
      swaggerdoc.click();
    },
    redirectopostman() {
      let postman = document.createElement("a");
      postman.target = "_blank";
      this.$api.apiToken
        .getPostmanUrl()
        .then((res) => {
          postman.href = res.data.postman_url;
          postman.click();
        })
        .catch((err) => {
          console.error("Error ", err);
        });
    },
  },
};
</script>

<style .scoped>
.Height-Class {
  height: calc(100vh - 124px);
}
</style>
